namespace Portico.Models {
    export class AuthenticationRequest {
        public portalId: string;
        public userName: string;
        public password: string;
        public action: AuthenticationAction;
        public jwt: string;
        public isParent: boolean;
    }
}